import { render } from "./BaseFilterButton.vue?vue&type=template&id=6dab7702"
import script from "./BaseFilterButton.vue?vue&type=script&lang=js"
export * from "./BaseFilterButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__